import { DataObject } from "core/types/DataObject";

/**
 * core/types/ShippingAddress
 * ----------------------------------------------------------------------
 * @since     0.0.1
 */
export class ShippingAddress extends DataObject {
  /**
   * @type {string}
   */
  shippingName = null;

  /**
   * @type {string|number}
   */
  shippingPostalCode = null;

  /**
   * @type {string|number}
   */
  shippingPhone = null;

  /**
   * @type {string}
   */
  shippingStreet = null;

  /**
   * @type {string}
   */
  shippingStreetExtension = null;

  /**
   * @type {string}
   */
  shippingStreetNeighborhood = null;

  /**
   * @type {string|number}
   */
  shippingStreetNumber = null;

  /**
   * @type {number}
   */
  shippingCityId = null;

  /**
   * @type {number}
   */
  shippingStateId = null;

  /**
   * @param {string} shippingName 
   * @param {string|number} shippingPostalCode 
   * @param {string|number} shippingPhone 
   * @param {string} shippingStreet 
   * @param {string} shippingStreetExtension 
   * @param {string} shippingStreetNeighborhood 
   * @param {string|number} shippingStreetNumber 
   * @param {string|number} shippingCityId 
   * @param {string|number} shippingStateId 
   */
  constructor (
    shippingName = null, 
    shippingPostalCode = null, 
    shippingPhone = null, 
    shippingStreet = null, 
    shippingStreetExtension = null, 
    shippingStreetNeighborhood = null, 
    shippingStreetNumber = null, 
    shippingCityId = null, 
    shippingStateId = null
  ) {
    super();

    this.shippingName = shippingName || null;
    this.shippingPostalCode = shippingPostalCode || null;
    this.shippingPhone = shippingPhone || null;
    this.shippingStreet = shippingStreet || null;
    this.shippingStreetExtension = shippingStreetExtension || null;
    this.shippingStreetNeighborhood = shippingStreetNeighborhood || null;
    this.shippingStreetNumber = shippingStreetNumber || null;
    this.shippingCityId = shippingCityId || null;
    this.shippingStateId = shippingStateId || null;
  }

  /**
   * Converte em POJO.
   * 
   * @param {boolean} notNullOnly 
   *     Se deve ignorar valores nulos ou indefinidos
   * @returns {object}
   * @override 
   */
  toObject (notNullOnly = false) {
    let keys = Object.keys(this),
        returnable = {};

    for (let key of keys) {
      if (typeof this[key] !== "function") {
        if (
          notNullOnly === true 
            && DataObject.isNullOrUndefined(this[key])
        ) {
          continue;
        }

        if (key === "shippingCityId") {
          let shippingCityKey = "shippingStateCityId";
          
          returnable[shippingCityKey] = this[key];
        } else {
          returnable[key] = this[key];
        }
      }
    }

    return returnable;
  }
}
